<template>
  <Layout>
    <!-- Start Contact Area  -->
    <div class="rwt-contact-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="rwt-video-popup-area rn-section-gap">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <SectionTitle
                      text-align="center"
                      subtitle="Installation Tutorial"
                      :title="videoTitle"
                  />
                </div>
              </div>
              <Video :video-data="videoData"/>
            </div>
          </div>
          <!--<div class="col-lg-12 mb&#45;&#45;40 text-center" data-aos="fade-up">
            <button class="btn-default btn-large" onClick="parent.location='https://www.youtube.com/watch?v=YsLrBcfl6PY'" formtarget="_blank">Tryone Solor Phone Mount</button>
          </div>
          <div class="col-lg-12 mb&#45;&#45;40 text-center" data-aos="fade-up">
            <button class="btn-default btn-large" onClick="parent.location='https://www.youtube.com/watch?v=QlRGi04ok88'" formtarget="_blank">Tryone Magsafe Phone Mount</button>
          </div>-->
        </div>
        <!--<div class="row mt&#45;&#45;40 row&#45;&#45;15">
          <div class="col-12">

          </div>
          &lt;!&ndash;<div class="col-lg-5 mt_md&#45;&#45;30 mt_sm&#45;&#45;30">
              <GoogleMap/>
          </div>&ndash;&gt;
        </div>-->
      </div>
    </div>
    <!-- End Contact Area  -->
  </Layout>
</template>

<script>
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle.vue'
import Layout from '@/components/common/Layout.vue'
import Video from '@/components/elements/video/Video.vue'

export default {
  name: 'InstallationPage',
  components: {Video, Layout, SectionTitle},
  computed: {
    videoTitle() {
      if (this.$route.params.product === 'glassSwitch2') {
        return 'Installation Instruction for Nintendo Switch OLED / Switch 2'
      } else if (this.$route.params.product === 'glassSwitch2-Tray') {
        return 'Installation Instruction with Application Tray for NS 2'
      } else if (this.$route.params.product === 'caseSwitch2') {
        return 'Installation Instruction for NS 2 Protective Case'
      } else {
        return 'Installation Instruction for Nintendo Switch 2017 / PS Portal'
      }
    },
    videoData() {
      if (this.$route.params.product === 'glassSwitch2') {
        return [
          {
            thumb: require(`@/assets/images/cover2.jpg`),
            src: 'https://www.youtube.com/watch?v=RPORzdkt8XU',
          },
        ]
      } else if (this.$route.params.product === 'glassSwitch2-Tray') {
        return [
          {
            thumb: require(`@/assets/images/cover2.jpg`),
            src: 'https://www.youtube.com/watch?v=RPORzdkt8XU',
          },
        ]
      } else if (this.$route.params.product === 'caseSwitch2') {
        return [
          {
            thumb: require(`@/assets/images/cover3.jpg`),
            src: 'https://www.youtube.com/watch?v=AZILOUqAdBI',
          },
        ]
      } else {
        return [
          {
            thumb: require(`@/assets/images/cover.png`),
            src: 'https://www.youtube.com/watch?v=HpNMK2wh4S4',
          },
        ]
      }
    },
  },
}

</script>

<style scoped>

</style>